module.exports = __webpack_public_path__ + "assets/images/background.6a5ed3b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/business-model/background.png
// module id = 250
// module chunks = 1